import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import GradientBar from '@/components/shared/GradientBar';
import { QRCodeSVG } from 'qrcode.react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const LandingPage = () => {
  const [landingImage, setLandingImage] = useState(null);
  const [qrLink, setQrLink] = useState('');

  // Fetch landing page image from backend
  useEffect(() => {
    const fetchLandingImage = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/settings/landing_image`);
        if (response.ok) {
          const data = await response.json();
          if (data.value) {
            setLandingImage(data.value);
          }
        }
      } catch (error) {
        console.error('Error fetching landing image:', error);
      }
    };
    
    fetchLandingImage();
  }, []);

  // Fetch QR link
  useEffect(() => {
    const fetchQrLink = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/settings/qr_link`);
        if (response.ok) {
          const data = await response.json();
          if (data.value) setQrLink(data.value);
        }
      } catch (error) {
        console.error('Error fetching QR link:', error);
      }
    };
    fetchQrLink();
  }, []);

  // Get current URL for QR code (fallback)
  const qrValue = qrLink || (typeof window !== 'undefined' ? window.location.origin : '');

  // Public landing view for both mobile and desktop.
  return (
    <div className="min-h-screen flex flex-col lg:flex-row overflow-auto lg:overflow-hidden" data-testid="landing-page">
      {/* Left Side - Gradient with Content */}
      <div className="w-full lg:w-1/2 min-h-screen">
        <GradientBar className="min-h-screen flex flex-col px-6 sm:px-8 py-6">
          {/* Logo */}
          <div className="flex-1 flex flex-col justify-center">
            <div className="text-center">
              <h1
                className="font-brand text-[36px] sm:text-[48px] text-brand-ink"
                data-testid="landing-logo"
              >
                Appstars
              </h1>
              <p className="font-['Lato'] text-[18px] text-gray-700 mt-1">
                stay uniq, embrace collectively
              </p>
              
              {/* Mobile Access Message */}
              <div className="mt-8">
                <p className="text-gray-700 text-sm">
                  Kullanıcı deneyimi mobil uygulama üzerinden devam eder.
                </p>
                
                {/* QR Code */}
                <div className="mt-4 flex justify-center">
                  <div className="bg-white p-3 rounded-xl shadow-lg">
                    <QRCodeSVG 
                      value={qrValue}
                      size={120}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="H"
                      includeMargin={false}
                    />
                  </div>
                </div>
                <p className="text-gray-600 text-xs mt-2">
                  QR kodu okutarak mobil uygulama bağlantısına geçin
                </p>
              </div>
            </div>
          </div>

          {/* Footer Links */}
          <footer className="pt-4 border-t border-brand-line">
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-700">
              <Link 
                to="/gizlilikpolitikasi" 
                className="hover:text-brand-ink transition-colors"
                data-testid="footer-privacy"
              >
                Gizlilik Politikası
              </Link>
              <Link 
                to="/kullanimkosullari" 
                className="hover:text-brand-ink transition-colors"
                data-testid="footer-terms"
              >
                Kullanım Koşulları
              </Link>
              <Link 
                to="/hakkimizda" 
                className="hover:text-brand-ink transition-colors"
                data-testid="footer-about"
              >
                Hakkımızda
              </Link>
              <Link 
                to="/kvkk" 
                className="hover:text-brand-ink transition-colors"
                data-testid="footer-kvkk"
              >
                KVKK Metni
              </Link>
            </div>
            <p className="text-center text-gray-500 text-xs mt-2">
              © 2026 Appstars. Tüm hakları saklıdır.
            </p>
          </footer>
        </GradientBar>
      </div>

      {/* Right Side - Image Area */}
      <div className="w-full lg:w-1/2 h-72 sm:h-96 lg:h-screen bg-gradient-to-br from-brand-neon to-brand-neon flex items-center justify-center">
        {landingImage ? (
          <img 
            src={landingImage} 
            alt=""
            className="w-full h-full object-cover"
            data-testid="landing-image"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div className="text-center text-brand-ink/40 p-10">
            <div className="w-32 h-32 mx-auto mb-6 rounded-2xl border-2 border-dashed border-brand-line flex items-center justify-center">
              <svg className="w-16 h-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <p className="text-sm">
              Görsel admin panelinden yüklenebilir
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LandingPage;
